import { Box, Modal, ModalDialog } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import { hrModalDialogSx } from "../../../styles/globalStyles";

export type LeaveReasonModalProps = {
  open: boolean;
  reasonText: string;
  onClose: () => void;
};

export default function LeaveReasonModal({ open, reasonText, onClose }: LeaveReasonModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ ...hrModalDialogSx, maxWidth: 700 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <DarkTypography level="title-md" colorVariant="title">
            Motif
          </DarkTypography>
        </Box>
        <DarkTypography
          colorVariant="primary"
          sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {reasonText}
        </DarkTypography>
      </ModalDialog>
    </Modal>
  );
}
